import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Colors } from 'modules/theme';

const SEARCH_INPUT_HEIGHT = 40;
const SEARCH_INPUT_RADIUS = 20;

const InputText = styled.input`
  width: 100%;
  height: ${SEARCH_INPUT_HEIGHT}px;
  box-sizing: border-box;
  border: 1px solid ${Colors.gray2};
  border-radius: ${SEARCH_INPUT_RADIUS}px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${Colors.black2};
  padding: 0 16px 0 40px;
  outline: none;
  background-color: ${Colors.white};
  transition: border-color 120ms ease, box-shadow 120ms ease;
  ::placeholder {
    font-size: 14px;
    color: ${Colors.gray};
  }
  &:focus {
    border-color: ${Colors.lightBlue};
    box-shadow: 0 0 0 3px rgba(20, 152, 203, 0.12);
  }
`;

const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
`;

const Icon = styled.i`
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: ${Colors.lightBlue};
  font-size: 14px;
  pointer-events: none;
`;

export default class InputSearch extends Component {
  state = {
    delayTyping: null,
    search: this.props.value ?? '',
  };

  componentDidMount() {
    if (this.props.value !== undefined && this.props.value !== this.state.search) {
      // Sync controlled value from URL/parent on mount
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({ search: this.props.value });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.value !== prevProps.value && this.props.value !== this.state.search) {
      // Sync controlled value when parent/URL changes
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ search: this.props.value ?? '' });
    }
  }

  handleChange = event => {
    const search = event.target.value;
    const { onChange } = this.props;

    clearTimeout(this.state.delayTyping);
    const delayTyping = setTimeout(() => {
      onChange(search);
    }, 1000);

    this.setState({
      search,
      delayTyping,
    });
  };

  render() {
    return (
      <Container>
        <Icon className="fas fa-search" />
        <InputText placeholder="Search" value={this.state.search} onChange={this.handleChange} />
      </Container>
    );
  }
}

InputSearch.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
};
